import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Footer, IssuerStatement } from 'shared-components';
import { withTheme } from 'styled-components';

export default withTheme(({ theme }) => {
  // Create intl instance
  const intl = useIntl();
  const formatLinks = Object.values(theme.brand.cbc_footer || {})
    .filter(link => link.url.trim()) // Only include links with a valid URL
    .map(link => ({
      title: intl.locale === 'fr' ? link.title_fr : link.title_en,
      url: link.url,
    }));
  const isCheckCardBalance = window.location.href.includes('checkcardbalance');
  const LegalStatments = [
    <IssuerStatement key="1">
      <FormattedMessage
        id="issuer-statement-p1-text"
        description="First paragraph of issuer statment"
        defaultMessage={intl.messages['issuer-statement-p1-text']}
      />
    </IssuerStatement>,
    <IssuerStatement key="2">
      <FormattedMessage
        id="issuer-statement-p2-text"
        description="Second paragraph of issuer statment"
        defaultMessage={intl.messages['issuer-statement-p2-text']}
      />
    </IssuerStatement>,
    <IssuerStatement key="3">
      {intl.messages['issuer-statement-p3-text'] === '' ? null : (
        <FormattedMessage
          id="issuer-statement-p3-text"
          description="Third paragraph of issuer statment"
          defaultMessage={intl.messages['issuer-statement-p3-text'] || null}
        />
      )}
    </IssuerStatement>,
  ];
  return (
    <Footer
      legalStatements={isCheckCardBalance ? [] : LegalStatments}
      companyName={
        isCheckCardBalance ? theme.brand.copyright_company_name : null
      }
      footerLinks={isCheckCardBalance ? formatLinks : null}
    />
  );
});
